// Enhanced validation function

export const MAX_TEXT_LEN = 200;
export const MAX_NOTES_LEN = 2000;
export const MAX_COVER_LETTER_LEN = 2000;
export const MIN_COVER_LETTER_LEN = 50;
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB


export const validateField = (name: string, value: string): { isValid: boolean; message?: string } => {
  switch (name) {
    case 'full_name':
      if (!value.trim()) return { isValid: false, message: 'Full name is required' };
      if (value.trim().length < 2) return { isValid: false, message: 'Full name must be at least 2 characters' };
      if (value.length > MAX_TEXT_LEN) return { isValid: false, message: `Full name must be less than ${MAX_TEXT_LEN} characters` };
      break;
    case 'email':
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value.trim()) return { isValid: false, message: 'Email is required' };
      if (!emailRegex.test(value)) return { isValid: false, message: 'Please enter a valid email address' };
      break;
    case 'phone':
      const phoneRegex = /^\+966[0-9\s\-()]{9,12}$/;
      if (!value.trim()) return { isValid: false, message: 'Phone number is required' };
      if (!phoneRegex.test(value)) return { isValid: false, message: 'Phone number must start with +966 and be 12-15 digits total' };
      break;
    case 'university':
      if (!value.trim()) return { isValid: false, message: 'University is required' };
      if (value.length > MAX_TEXT_LEN) return { isValid: false, message: `University name must be less than ${MAX_TEXT_LEN} characters` };
      break;
    case 'major':
      if (!value.trim()) return { isValid: false, message: 'Major is required' };
      if (value.length > MAX_TEXT_LEN) return { isValid: false, message: `Major must be less than ${MAX_TEXT_LEN} characters` };
      break;
    case 'gpa':
      const gpa = parseFloat(value);
      if (isNaN(gpa)) return { isValid: false, message: 'GPA must be a valid number' };
      if (gpa < 0 || gpa > 5) return { isValid: false, message: 'GPA must be between 0 and 5' };
      break;
    case 'gpa_system':
      const gpa_max = parseFloat(value);
      if (isNaN(gpa_max)) return { isValid: false, message: 'GPA Max must be a valid number' };
      if (gpa_max < 0 || gpa_max > 5) return { isValid: false, message: 'GPA Max must be between 0 and 5' };
      break;
    case 'cover_letter':
      if (!value.trim()) return { isValid: false, message: 'Cover letter is required' };
      if (value.trim().length < MIN_COVER_LETTER_LEN) return { isValid: false, message: `Cover letter must be at least ${MIN_COVER_LETTER_LEN} characters` };
      if (value.length > MAX_COVER_LETTER_LEN) return { isValid: false, message: `Cover letter must be less than ${MAX_COVER_LETTER_LEN} characters` };
      break;
    case 'notes':
      if (value.length > MAX_NOTES_LEN) return { isValid: false, message: `Notes must be less than ${MAX_NOTES_LEN} characters` };
      break;
      case 'password':
        if (!value.trim()) return { isValid: false, message: 'Password is required' };
        if (value.length < 6) return { isValid: false, message: 'Password must be at least 6 characters' };
        if (value.length > 128) return { isValid: false, message: 'Password must be less than 128 characters' };
        break;
  }
  return { isValid: true };
};

  
// Validation function for login fields
export  const validateLoginField = (name: string, value: string): { isValid: boolean; message?: string } => {
  switch (name) {
    case 'email':
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value.trim()) return { isValid: false, message: 'Email is required' };
      if (!emailRegex.test(value)) return { isValid: false, message: 'Please enter a valid email address' };
      if (value.length > 100) return { isValid: false, message: 'Email must be less than 100 characters' };
      break;
    case 'password':
      if (!value.trim()) return { isValid: false, message: 'Password is required' };
      if (value.length < 6) return { isValid: false, message: 'Password must be at least 6 characters' };
      if (value.length > 128) return { isValid: false, message: 'Password must be less than 128 characters' };
      break;
  }
  return { isValid: true };
};
